module.exports = __webpack_public_path__ + "static/media/imac-scrn-consultancy.7d10a24c.jpg";